import axios, {type AxiosInstance} from "axios";

const BASE_URL = import.meta.env.VITE_API_BASE_URL || "";

export const api: AxiosInstance = axios.create({
    baseURL: `${BASE_URL}/api/v1`,
    withCredentials: true,
});

export async function baseRequest<T = any>(
    url: string,
    options: {
        method?: "GET" | "POST" | "PUT" | "DELETE" | "PATCH";
        data?: any;
        headers?: Record<string, string>;
        params?: Record<string, any>;
    } = {}
): Promise<T | null> {
    try {
        const response = await api.request({
            url,
            method: options.method || "GET",
            data: options.data,
            params: options.params,
            headers: options.headers,
        });
        if (response.data === "" || response.data === undefined) return null;
        return response.data;
    } catch (err: any) {
        if (axios.isAxiosError(err)) {
            const payload = err.response?.data ?? err.message;
            if (payload && typeof payload === "object" && "message" in payload) {
                throw new Error(String((payload as any).message));
            }
            throw new Error(typeof payload === "string" ? payload : JSON.stringify(payload));
        }
        throw err;
    }
}
